var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Navbar'),_c('div',[_c('h4',[_vm._v("Events")]),_vm._l((_vm.events),function(event){return _c('div',{key:event.id},[_c('EventItem',{attrs:{"event":event}})],1)})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }